import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Table,
  Row,
  Col,
  Input,
  Search,
  SelectOption,
  Select,
} from 'components/ui';
import { Loading } from 'components/blocks';
import { showErrorNotification } from 'services/common';
import './style.css';
import { Modal } from 'turing-uiux';
import { MIN_INPUT_LENGTH } from 'constants/common';
import reduce from 'lodash/reduce';
import { user as userImage } from 'assets/img';
import { Avatar } from 'antd';
import EditUserButton from './EditUserButton';
import { USER_ROLES } from '../../../constants/auth';

class UserManagement extends Component {
  state = {
    showUserModal: false,
    activeUserId: -1,
    showResetPasswordModal: false,
    showDeleteUserModal: false,
    newPassword: '',
    errors: {},
  };

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  handleDeleteUser = user => {
    const params = { user_id: this.state.activeUserId };
    this.props.onDeleteUser(params);
    this.handleHideDeleteUserModal();
  };

  handleDeleteUserModal = event => {
    let { id } = event.target;
    id = Number(id.replace('delete-', ''));
    this.setState({
      activeUserId: id,
      showDeleteUserModal: true,
    });
  };

  handleHideResetPasswordModal = () => {
    this.setState({ showResetPasswordModal: false, newPassword: '' });
  };

  handleHideDeleteUserModal = () => {
    this.setState({ showDeleteUserModal: false });
  };

  displayErrors = emptyValues => {
    const errors = reduce(
      emptyValues,
      (acc, value, key) => {
        acc[key] =
          value && value.trim()
            ? `Should have at least ${MIN_INPUT_LENGTH} characters`
            : 'Required';
        return acc;
      },
      {},
    );
    this.setState({ errors });
  };

  clearError = key => ({ ...this.state.errors, [key]: '' });

  handleInputChange = event => {
    const { value, name } = event.target;
    const errors = this.clearError(name);
    this.setState({ [name]: value, errors });
  };

  getTableColumns = () => {
    const { currentUser } = this.props;
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Full Name',
        dataIndex: 'full_name',
        key: 'full_name',
        render: (name, data) => {
          const { id, userName, fullName, avatar } = data;
          let nameRender = `${fullName || userName}`;
          if (id === currentUser?.id) nameRender += ' (You)';
          return (
            <div className="flex items-center space-x-4">
              <Avatar src={avatar || userImage} />
              <p style={{ marginBottom: 0 }}>{nameRender}</p>
            </div>
          );
        },
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Role',
        dataIndex: 'roles',
        key: 'roles',
        render: roles => {
          return roles[0]?.name;
        },
      },
      {
        title: 'Actions',
        dateIndex: 'actions',
        key: 'actions',
        render: (_, user) => {
          const { id } = user;
          if (Number(currentUser?.id) === Number(id)) {
            return null;
          }
          return (
            <div className="flex items-center space-x-4">
              <EditUserButton user={user} />
              <Button
                className="users__delete-password-btn"
                id={`delete-${id}`}
                type="button"
                onClick={this.handleDeleteUserModal}
              >
                Delete User
              </Button>
            </div>
          );
        },
      },
    ];
  };

  getTableData = () => this.props.users;

  searchInUsers = value => {
    this.props.setSearch(value);
  };

  render() {
    const {
      isLoading,
      totalUsers,
      setLimit,
      setPage,
      page,
      limit,
    } = this.props;
    const {
      showResetPasswordModal,
      newPassword,
      showDeleteUserModal,
      errors,
    } = this.state;

    return (
      <div className="users">
        <Row className="users__header">
          <Col span={12}>
            <h1 cy-data="users-title">
              User Management
              {isLoading && <Loading />}
            </h1>
          </Col>
          <Col span={12}>
            <div
              className="flex items-center space-x-4"
              style={{ justifyContent: 'flex-end' }}
            >
              <Select
                defaultValue={0}
                onChange={value => this.props.setRole(value)}
              >
                <SelectOption key="default" value={0}>
                  All Roles
                </SelectOption>
                {Object.keys(USER_ROLES).map(role => (
                  <SelectOption key={role} value={role}>
                    {role}
                  </SelectOption>
                ))}
              </Select>
              <Search
                allowClear
                className="search_templates"
                placeholder="Search Users"
                style={{ width: 400 }}
                onChange={event => {
                  this.searchInUsers(event.target.value);
                }}
              />
            </div>
          </Col>
        </Row>
        <Table
          columns={this.getTableColumns()}
          dataSource={this.getTableData()}
          pagination={{
            total: totalUsers,
            current: page,
            pageSize: limit,
            showSizeChanger: true,
            onChange: newPage => {
              setPage(newPage);
            },
            onShowSizeChange: (current, size) => {
              setPage(1);
              setLimit(size);
            },
          }}
          rowKey="id"
        />
        <Modal
          visible={showResetPasswordModal}
          onCancel={this.handleHideResetPasswordModal}
          onOk={this.handleResetPassword}
        >
          <div className="reset-password-modal">
            <Row gutter={8}>
              <Col span={12}>
                <Input
                  error={errors.newPassword}
                  helperTxt={errors.newPassword}
                  id="reset-password-input"
                  label="New Password"
                  name="newPassword"
                  placeholder="P@ssw0rd"
                  value={newPassword}
                  onChange={this.handleInputChange}
                />
              </Col>
            </Row>
          </div>
        </Modal>
        <Modal
          visible={showDeleteUserModal}
          onCancel={this.handleHideDeleteUserModal}
          onOk={this.handleDeleteUser}
        >
          <div className="delete-user-modal">
            <Row gutter={8}>Are you sure you want to delete the user?</Row>
          </div>
        </Modal>
      </div>
    );
  }
}

UserManagement.defaultProps = {
  isLoading: false,
  users: [],
  totalUsers: 0,
};

UserManagement.propTypes = {
  error: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  limit: PropTypes.number,
  page: PropTypes.number,
  setLimit: PropTypes.func,
  setPage: PropTypes.func,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number,
      name: PropTypes.string,
      email: PropTypes.string,
      role: PropTypes.string,
    }),
  ),
  totalUsers: PropTypes.number,
  onAddUser: PropTypes.func.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
  onResetUserPassword: PropTypes.func.isRequired,
  onDeleteUser: PropTypes.func.isRequired,
};

export default UserManagement;
